let _host = window.location.host.split('.')[0];
if (!['shop', 'welcome'].includes(_host)) {
  _host = 'welcome';
}

export const HOST = _host;

export interface ILoginParams {
  project: string;
  uri: string;
}

export namespace LogUser {
  export namespace Urls {
    /**
     * logout -> return to project
     */
    export const logout = `/auth/logout`;
    /**
     * login -> redirect to project
     */
    export const login = `/auth/login`;
    /**
     * logout -> login -> return to project
     */
    export const logoutWithLoginRedirect = `${logout}?with_login_redirect=1`;
  }

  export namespace Action {
    export const logout = () => {
      window.location.assign(`${LogUser.Urls.logout}?project=${HOST}&uri=/`);
    };

    export const login = (params?: ILoginParams) => {
      window.location.assign(`${LogUser.Urls.login}?project=${params?.project ?? HOST}&uri=${params?.uri ?? "/"}`);
    };

    export const logoutWithLoginRedirect = () => {
      window.location.assign(`${LogUser.Urls.logoutWithLoginRedirect}?project=${HOST}&uri=/`);
    };
  }
}


